<script>
import Swal from "sweetalert2";
import moment from "moment";

// Custom components
import PageHeader from "@/components/page-header";
import BookingService from "@/helpers/APIService/booking.service";
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Up Sell",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    PageHeader,
  },
  data() {
    return {
      title: "Up Sell Order",
      table: {
        tableData: [],
      },
      rejectReason: null,
      chargeType: null,
      isDataLoading: false,
      currency: "$",
    };
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    this.upSellOrderList("pending");
    this.currency = this.hotel.currency === "usd" ? "$" : "₹";
  },
  methods: {
    // Method is use for get upSell order list
    async upSellOrderList(status) {
      try {
        this.isDataLoading = true;
        let filter = `?approve_status=${status}`;
        const response = await BookingService.getUpsellOrderByFilter(filter);
        if (response !== undefined || response !== null) {
          this.isDataLoading = false;
          this.table.tableData = response;
        }
        const chargesResponse = await UserService.getChargesTypeList();
        if (chargesResponse !== undefined) {
          chargesResponse.map((charge) => {
            if (charge.name == "Upsell") {
              this.chargeType = charge.id;
            }
          });
        }
      } catch (error) {
        this.isDataLoading = false;
        errorHandler(error);
      }
    },
    // Approve upSell order
    approvedUpSell(data) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won to Accept!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, Accepted!",
      }).then(async (result) => {
        if (result.value) {
          try {
            let extraCharges = data.upsell.price;
            if (data.upsell.price_type == "percentage") {
              extraCharges = parseFloat(data.amount * extraCharges) / 100;
            }
            if (
              data.upsell.base_on == "guest" ||
              data.upsell.base_on == "adult"
            ) {
              extraCharges =
                parseFloat(data.guest.length) * parseFloat(data.upsell.price);
            }

            if (data.period == "daily") {
              var startDate = moment(
                data.booking.check_in_date[0],
                "YYYY-MM-DD"
              );
              var endDate = moment(
                data.booking.check_out_date[1],
                "YYYY-MM-DD"
              );
              let stay_night = endDate.diff(startDate, "days");
              extraCharges = parseFloat(stay_night) * parseFloat(extraCharges);
            }
            const response = await BookingService.addAdditionalCharge(
              data.booking.id,
              {
                booking: data.booking.id,
                description: data.upsell.short_description,
                debit: extraCharges,
                charge_type: this.chargeType,
                upsell: data.upsell.id,
              }
            );
            if (response !== undefined || response != null) {
              let upSellData = {
                approve_status: "approved",
                folio_transaction: response.id,
              };
              const upSellUpdateResponse =
                await BookingService.updateUpsellOrder(
                  data.booking.id,
                  data.id,
                  upSellData
                );
              Middleware.notification("Successfully approved !!", "success");
              this.table.tableData = this.table.tableData.map((item) => {
                if (item.id == upSellUpdateResponse.id) {
                  item = {
                    ...item,
                    approve_status: upSellUpdateResponse.approve_status,
                    reject_reason: upSellUpdateResponse.reject_reason,
                  };
                }
                return item;
              });
            }
          } catch (error) {
            errorHandler(error);
          }
        }
      });
    },
    // Reject upSell order
    rejectUpSell(data) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won to Reject!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, Reject!",
        input: "text",
        inputPlaceholder: "Please Enter Reject Reason.",
        inputAutoTrim: true,
        showLoaderOnConfirm: true,
        inputValidator: (value) => {
          if (!value) {
            return "You need to write something!";
          }
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          const upSellUpdateResponse = await BookingService.updateUpsellOrder(
            data.booking.id,
            data.id,
            { approve_status: "rejected", reject_reason: result.value }
          );
          Middleware.notification("Successfully rejected !!", "success");

          this.table.tableData = this.table.tableData.map((item) => {
            if (item.id == upSellUpdateResponse.id) {
              item = upSellUpdateResponse;
            }
            return item;
          });
        }
      });
    },
  },
};
</script>

<template>
  <div>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <b-tabs justified nav-class="nav-tabs-custom">
              <b-tab active @click="upSellOrderList('pending')">
                <template v-slot:title>
                  <span class="d-none d-sm-inline-block">Pending Upsell</span>
                </template>
              </b-tab>
              <b-tab @click="upSellOrderList('approved')">
                <template v-slot:title>
                  <span class="d-none d-sm-inline-block">Approved Upsell</span>
                </template>
              </b-tab>
              <b-tab @click="upSellOrderList('rejected')">
                <template v-slot:title>
                  <span class="d-none d-sm-inline-block"
                    >Reject/Void Upsell</span
                  >
                </template>
              </b-tab>
            </b-tabs>
            <div class="row">
              <div class="col-12 mt-2">
                <div class="table-responsive mb-0" v-dragscroll>
                  <table
                    class="table table-hover mb-0"
                    ref="my-table"
                    infinite-scroll-disabled="busy"
                    infinite-scroll-distance="10"
                  >
                    <thead class="table-light">
                      <tr>
                        <th>Title</th>
                        <th>Booking Ref</th>
                        <th>Price</th>
                        <th>Period</th>
                        <th>
                          <div class="d-flex">
                            Check-In
                            <i
                              class="fas fa-long-arrow-alt-right fs-4 mx-1 text-center"
                            ></i>
                            Check-Out
                          </div>
                        </th>
                        <th>Guest Name</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody v-if="isDataLoading">
                      <tr v-for="item in 13" :key="item">
                        <td class="placeholder-glow" v-for="no in 8" :key="no">
                          <span class="placeholder w-100 placeholder-lg"></span>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr v-for="(data, index) in table.tableData" :key="index">
                        <td>
                          {{ data.upsell !== null ? data.upsell.title : "-" }}
                        </td>
                        <td>
                          {{
                            data.booking !== null
                              ? data.booking.reference_no
                              : "-"
                          }}
                        </td>
                        <td>
                          {{ currency }}
                          {{
                            data.upsell.price !== null ? data.upsell.price : "-"
                          }}
                        </td>
                        <td>
                          {{
                            data.upsell.period !== null
                              ? data.upsell.period == "one_time"
                                ? "One Time"
                                : "Daily"
                              : "-"
                          }}
                        </td>
                        <td v-if="data.booking !== null">
                          {{ data.booking.check_in_date }}
                          <i
                            class="fas fa-long-arrow-alt-right fs-5 text-center"
                          ></i>
                          {{ data.booking.check_out_date }}
                        </td>
                        <td v-else>{{ "-" }}</td>
                        <td>
                          {{
                            data.booking !== null
                              ? data.booking.primary_guest_first_name +
                                " " +
                                data.booking.primary_guest_last_name
                              : "-"
                          }}
                        </td>
                        <td>
                          <span
                            class="badge align-items-center py-1 px-2 card-badge"
                            :class="[
                              data.approve_status === 'approved'
                                ? 'badge-soft-success'
                                : data.approve_status === 'pending'
                                ? 'badge-soft-warning'
                                : data.approve_status === 'void'
                                ? 'badge-soft-secondary'
                                : data.approve_status === 'rejected'
                                ? 'badge-soft-danger'
                                : 'badge-soft-primary',
                            ]"
                          >
                            {{
                              data.approve_status === "approved"
                                ? "Approved"
                                : data.approve_status === "pending"
                                ? "Pending"
                                : data.approve_status === "void"
                                ? "Voided"
                                : data.approve_status == "rejected"
                                ? "Rejected"
                                : data.approve_status
                            }}
                          </span>
                          <i
                            v-if="data.approve_status == 'rejected'"
                            class="fa fa-info-circle fa-xs text-muted ml-1 ms-1"
                            v-b-popover.hover.top="data.reject_reason"
                          ></i>
                        </td>
                        <td>
                          <div
                            class="d-flex align-items-center"
                            v-if="data.approve_status == 'pending'"
                          >
                            <i
                              class="fas fa-check-square mx-1 fs-5"
                              v-b-popover.hover="'Accept UpSell'"
                              id="accept"
                              @click="approvedUpSell(data)"
                            ></i>
                            <i
                              class="fas fa-window-close mx-1 fs-5"
                              v-b-popover.hover="'Reject UpSell'"
                              id="rejected"
                              @click="rejectUpSell(data)"
                            ></i>
                          </div>
                          <span v-else>{{ "-" }}</span>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-if="!isDataLoading && table.tableData.length == 0">
                      <tr>
                        <td colspan="9" class="text-center">
                          <img
                            src="@/assets/images/empty.svg"
                            class="img-fluid"
                            alt=""
                          />
                          <p>
                            <span class="text-secondary">No Data Found</span>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
